import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom"; // 路由链接（若项目有对应页面）
import { useState } from "react";
// 引入页脚背景图（需放入 src/assets/images/）
import footerBg from "../assets/images/footer-bg.jpg";
import "./FooterSection.scss";
import logo from "../assets/images/logo.webp";
import logoEn from "../assets/images/logoEN.png";
import Modal from "./global/Modal";
import privacyContent from "./privacy-zh.js";
import privacyContentEn from "./privacy-en.js";

const FooterSection = () => {
  const { t, i18n } = useTranslation();
  // 动态切换LOGO：英文环境用 logoEn，其他用默认 logo
  const currentLogo = i18n.language === "en" ? logoEn : logo;
  const currentPrivacyContent =
    i18n.language === "en" ? privacyContentEn : privacyContent;
  const [htmlModalVisible, setHtmlModalVisible] = useState(false);
  const [declareModalVisible, setDeclareModalVisible] = useState(false);
  // 示例：普通文本内容
  const normalContent =
    "这是一个通用弹窗，可展示任意内容，比如提示信息、表单、详情等。";

  // 示例：HTML内容
  const htmlContent = `
  <h3>用户协议</h3>
  <p>1. 您使用本服务前，需仔细阅读并同意本协议全部内容；</p>
  <p>2. 未经授权，禁止转载本平台所有原创内容；</p>
  <p>3. 如有疑问，请联系客服：400-123-4567</p>
`;
  return (
    <footer className='footer-section'>
      <div className='footer-top g-inner'>
        <img src={currentLogo} alt='yield-royal' className='logo' />
        {/* <div className='footer-links'>
          <span className='iconfont'>&#xe87f;</span>
          <span className='iconfont'>&#xe69d;</span>
          <span className='iconfont'>&#xe69b;</span>
        </div> */}
      </div>
      <div
        className='footer-bg g-inner'
        style={{ backgroundImage: `url(${footerBg})` }}
      >
        <div className='container'>
          {/* 导航分栏 */}
          <div className='footer-nav'>
            <div className='nav-column'>
              <a className='nav-link' href={`#` + t("navbar.home")}>
                {t("navbar.home")}
              </a>
              <a className='nav-link' href={`#` + t("navbar.about")}>
                {t("navbar.about")}
              </a>
              <a className='nav-link' href={`#` + t("navbar.investment")}>
                {t("navbar.investment")}
              </a>
              <a className='nav-link' href={`#` + t("navbar.csr")}>
                {t("navbar.csr")}
              </a>
              <a className='nav-link' href={`#` + t("navbar.contact")}>
                {t("navbar.contact")}
              </a>
            </div>
            {/* <div className='nav-column'>
              <div
                className='nav-link'
                onClick={() => setHtmlModalVisible(true)}
              >
                {t("footer.navPrivacy")}
              </div>
              <div
                className='nav-link'
                onClick={() => setDeclareModalVisible(true)}
              >
                {t("footer.navStatement")}
              </div>
            </div> */}
          </div>

          {/* 版权信息 */}
          <div className='footer-copyright'>
            <p>© 2025 {t("footer.copyright")} </p>
          </div>
        </div>
      </div>
      {/* HTML内容弹窗（禁止点击遮罩关闭） */}
      <Modal
        visible={htmlModalVisible}
        onClose={() => setHtmlModalVisible(false)}
        title={t("footer.navPrivacy")}
        content={currentPrivacyContent}
      />
      <Modal
        visible={declareModalVisible}
        onClose={() => setDeclareModalVisible(false)}
        title={t("footer.navStatement")}
        content={currentPrivacyContent}
      />
    </footer>
  );
};

export default FooterSection;
